import styles from "./WorkShowCase.module.css";

export default function WorkShowCase({
  eyebrow = "",
  heading = "",
  description = "",
  items = [],
}) {
  if (!heading || items.length === 0) {
    return null;
  }

  const repeatedItems = [...items, ...items];

  return (
    <section className={styles.section}>
      <div className={styles.shell}>
        <div className={styles.header}>
          {eyebrow ? <span className={styles.eyebrow}>{eyebrow}</span> : null}
          <h2>{heading}</h2>
          {description ? <p>{description}</p> : null}
        </div>

        <div className={styles.sliderViewport}>
          <div className={styles.sliderTrack}>
            {repeatedItems.map((item, index) => (
              <article key={`${item.title}-${index}`} className={styles.card}>
                <div className={styles.cardMain}>
                  <div className={styles.iconPanel}>
                    <div className={styles.iconOrb} />
                    <span className={styles.iconWrap}>{item.icon}</span>
                  </div>

                  <div className={styles.cardBody}>
                    <h3>{item.title}</h3>
                    <p>{item.desc}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
